import { FormIODataService } from "./services/formio-data.service";
// Angular
import { NgModule } from "@angular/core";
// BBWT

import { FilterModule } from "@features/filter";
import { GridModule } from "@features/grid";

import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Formio, FormioModule, Templates } from "@formio/angular";
import { PrimeNgModule } from "@primeng";
import { BbFormBuilderComponent } from "./components/bb-form-builder/bb-form-builder.component";
import { BbFormRendererComponent } from "./components/bb-form-renderer/bb-form-renderer.component";
import { BbUserSignatureComponent } from "./components/bb-user-signature/user-signature.component";
import { PrismService } from "./prism.service";
import { FormIODefinitionService } from "./services/formio-definition.service";
import { UserSignatureService } from "./services/user-signature.service";
import { FormIODataDraftService } from "./services/formio-data-draft.service";
import attachmentsTemplate from "./components/custom-components/file-upload/template/form";
import BodyMapComponent from "./components/custom-components/body-map/BodyMap";
import FileUpload from "./components/custom-components/file-upload/FileAttachments";
import { BbImageUploaderModule } from "@features/bb-image-uploader";
import ImageUploaderLauncherComponent from "./components/custom-components/image-uploader/ImgUploaderBtn";
import { S3Service } from "./Providers/s3";
import { FormIORevisionService } from "./services/formio-revision.service";
import TabsComponent from "./components/custom-components/tabs/Tabs";
import tabTemplate from "./components/custom-components/tabs/template/template";
import { BBFormSaveDialogComponent } from "./components/form-save-dialog/bb-form-save-dialog.component";
import ReviewerInputComponent from "./components/custom-components/reviewer-input/ReviewerInput";
import SurveyComponent from "./components/custom-components/survey/Survey";
import {BbFormVersionHandlerComponent} from "@features/bb-formio/components/bb-form-version-handler/bb-form-version-handler.component";
import { EpisodeModule } from "@project/episode/episode.module";
import { OfflineModule } from "@main/offline/offline.module";
import { FormIOEpisodeSelectDialogComponent } from "@main/formio/components/formio-episode-select-dialog/formio-select-episode-dialog.component";
import { FormIOPatientSelectDialogComponent } from "@main/formio/components/formio-patient-select-dialog/formio-select-patient-dialog.component";
import { PatientSelectModule } from "@project/patient-select/patient-select.module";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import {
    FormIOFormSelectDialogComponent
} from "@main/formio/components/formio-form-select-dialog/formio-select-form-dialog.component";
import { FormioModuleFillFormComponent } from "@main/formio/components/formio-module-fill-form/formio-module-fill-form.component";
import {
    FormIOFilteredFormSelectDialogComponent
} from "@main/formio/components/formio-filtered-form-select-dialog/formio-filtered-form-select-dialog.component";
import { FormioTagsService } from "@main/formio/services/formio-tags.service";
import { MultiUserFormCreateInstanceComponent } from "@main/formio/multi-user-form/multi-user-form-create-instance/multi-user-form-create-instance.component";
import { FormIOShareDialogComponent } from "@main/formio/components/formio-share-dialog/formio-share-dialog.component";
import { FormioRequestService } from "@main/formio/services/formioRequest.service";
import { FormIOFormRequestDialogComponent } from "@main/formio/components/formio-form-request-dialog/formio-form-request-dialog.component";
import { FormioAllInstancesComponent } from "@main/formio/components/formio-all-instances/formio-all-instances.component";
import MiProMedHistDatagridComponent from "./components/custom-components/mipro-data-grid/MiproMedHistDataGrid";
import MiproConsultHistDataGrid from "./components/custom-components/mipro-data-grid/MiproConsultHistDataGrid";
import MiproEpisodeNotesDataGrid from "./components/custom-components/mipro-data-grid/MiproEpisodeNotesDataGrid";
import MiproClinicianNameTextField from "./components/custom-components/mipro-user-patient-info/MiproClinicianNameTextField";
import MiproClinicianOrgTextField from "./components/custom-components/mipro-user-patient-info/MiproClinicianOrgTextField";
import MiproClinicianRegistrationNoTextField from "./components/custom-components/mipro-user-patient-info/MiproClinicianRegistrationNoTextField";
import MiproPatientNameTextField from "./components/custom-components/mipro-user-patient-info/MiproPatientNameTextField";
import MiproPatientAddressTextField from "./components/custom-components/mipro-user-patient-info/MiproPatientAddressTextField";
import MiproPatientAgeNumber from "./components/custom-components/mipro-user-patient-info/MiproPatientAgeNumber";
import MiproPatientDateOfBirth from "./components/custom-components/mipro-user-patient-info/MiproPatientDateOfBirth";
import MiproVariableField from "./components/custom-components/mipro-variable-field/mipro-variable-field";
import MiproSignatureField from "./components/custom-components/mipro-user-patient-info/MiproSignatureField";
import MiproClinicianEmailField from "./components/custom-components/mipro-user-patient-info/MiproClinicianEmailField";
import MiproPatientEmailField from "./components/custom-components/mipro-user-patient-info/MiproPatientEmailField";
import MiproPatientPhoneField from "./components/custom-components/mipro-user-patient-info/MiproPatientPhoneField";
import MiproClinicianPhoneField from "./components/custom-components/mipro-user-patient-info/MiproClinicianPhoneField";
import MiproConsultHistDataGridV2 from "@features/bb-formio/components/custom-components/mipro-data-grid/MiproConsultHistDataGridV2";
import { ExistingFormDataDraftComponent } from "@main/formio/components/existing-form-data-draft/existing-form-data-draft.component";
import { FormEventWorkflowComponent } from "@main/formio/components/form-events/form-event-workflow.component";
import { MedicalRecordEmptyListComponent } from "@project/medical-record/medical-record-empty-list.component";
import { FormIOCategoryService } from "@main/formio/services/formioCategory.service";
import { FormIOModuleService } from "@main/formio/services/formio-module.service";

@NgModule({
    declarations: [
        BbFormBuilderComponent,
        BbFormRendererComponent,
        BbUserSignatureComponent,
        BBFormSaveDialogComponent,
        BbFormVersionHandlerComponent,
        FormIOEpisodeSelectDialogComponent,
        FormIOPatientSelectDialogComponent,
        FormIOShareDialogComponent,
        FormIOFormSelectDialogComponent,
        FormIOFilteredFormSelectDialogComponent,
        FormioModuleFillFormComponent,
        FormioAllInstancesComponent,
        MultiUserFormCreateInstanceComponent,
        FormIOFormRequestDialogComponent,
        ExistingFormDataDraftComponent,
        FormEventWorkflowComponent
    ],
    imports: [
        GridModule,
        CommonModule,
        FilterModule,
        FormioModule,
        FormsModule,
        PrimeNgModule,
        BbImageUploaderModule,
        EpisodeModule,
        ReactiveFormsModule,
        OfflineModule,
        MiproSharedModule,
        PatientSelectModule,
        MedicalRecordEmptyListComponent
    ],

    exports: [
        BbFormBuilderComponent,
        BbFormRendererComponent,
        BbUserSignatureComponent,
        FormIOEpisodeSelectDialogComponent,
        FormIOPatientSelectDialogComponent,
        FormIOFormSelectDialogComponent,
        FormIOFilteredFormSelectDialogComponent,
        FormioModuleFillFormComponent,
        FormioAllInstancesComponent,
        MultiUserFormCreateInstanceComponent,
        FormIOFormRequestDialogComponent,
        ExistingFormDataDraftComponent,
        FormEventWorkflowComponent
    ],
    providers: [
        PrismService,
        UserSignatureService,
        FormIODataService,
        FormIODataDraftService,
        FormIODefinitionService,
        FormIOCategoryService,
        FormIOModuleService,
        S3Service,
        FormIORevisionService,
        FormioTagsService,
        FormioRequestService
    ]
})
export class BbFormIOModule {
    constructor () {
        // Formio.use(customComponents);
        Formio.registerPlugin(BodyMapComponent, "bodyMapComponent");
        Formio.registerPlugin(FileUpload, "attachmentsComponent");
        Formio.registerPlugin(ImageUploaderLauncherComponent, "imageUploaderLauncherComponent");
        Formio.registerPlugin(TabsComponent, "state-tabs");
        Formio.registerPlugin(ReviewerInputComponent, "reviewerInput");
        Formio.registerPlugin(MiproVariableField, "miproVariableField");
        Formio.registerPlugin(SurveyComponent, "survey");
        Formio.registerPlugin(MiProMedHistDatagridComponent, "miproMedHistDatagrid");
        Formio.registerPlugin(MiproConsultHistDataGrid, "miproConsultHistDatagrid");
        Formio.registerPlugin(MiproConsultHistDataGridV2, "miproConsultHistDatagridV2");
        Formio.registerPlugin(MiproEpisodeNotesDataGrid, "miproEpisodeNotesDatagrid");
        Formio.registerPlugin(MiproClinicianNameTextField, "miproClinicianNameTextField");
        Formio.registerPlugin(MiproClinicianOrgTextField, "miproClinicianOrgTextField");
        Formio.registerPlugin(MiproClinicianRegistrationNoTextField, "miproClinicianRegistrationNoTextField");
        Formio.registerPlugin(MiproPatientNameTextField, "miproPatientNameTextField");
        Formio.registerPlugin(MiproPatientAddressTextField, "miproPatientAddressTextField");
        Formio.registerPlugin(MiproPatientAgeNumber, "miproPatientAgeNumber");
        Formio.registerPlugin(MiproPatientDateOfBirth, "miproPatientDateOfBirth");
        Formio.registerPlugin(MiproSignatureField, "miproSignatureField");
        Formio.registerPlugin(MiproClinicianEmailField, "miproClinicianEmailField");
        Formio.registerPlugin(MiproPatientEmailField, "miproPatientEmailField");
        Formio.registerPlugin(MiproPatientPhoneField, "miproClinicianPhoneField");
        Formio.registerPlugin(MiproClinicianPhoneField, "miproClinicianPhoneField");


        // Add custom templates to the list of available templates
        // used in FileAttachments.ts renderTemplate() method
        // template HTML can be found at app\features\bb-formio\components\custom-components\file-upload\template\form.ts
        Templates.current = {
            attachmentsTemplate: {
                form: (ctx: any): string => attachmentsTemplate(ctx)
            },
            tabTemplate: {
                form: (ctx: any): string => tabTemplate(ctx)
            }
        }
    }
 }